import Grid from '@mui/material/Grid2';
import { TypographyStepTitle, TypographyInstruction, } from '../style/typography';

export default function PowerplantPatrol({ title }) {
  return (
    <Grid size={12}>
      <TypographyStepTitle sx={{borderLeft: '5px solid #0A7CB7'}}>{title}</TypographyStepTitle>
    </Grid>
  );
}